<template>
  <div :style="{ width: width || '100%' }" class="edit-form">
    <el-form
      :model="formData"
      :rules="rules"
      ref="formData"
      :disabled="formConfig.disabled || false"
      :label-width="formConfig.labelWidth || '140px'"
      class="edit-form"
    >
      <div v-for="(row, index) in formConfig.items" :key="index">
        <div
          v-for="(item, i) in row"
          :key="i"
          :style="{ width: item.itemWidth || formConfig.itemWidth || '30%' }"
        >
          <div v-if="showItem(formData, item.show)" class="form-item-box">
            <el-form-item
              :prop="item.prop"
              :label-width="item.labelWidth"
              :label="item.label"
            >
              <!-- 生成框 -->
              <span v-if="item.valueType === 'text'">{{
                formData[item.key]
              }}</span>
              <!-- 计数器 -->
              <el-input-number
                :style="{ width: item.inputWidth }"
                v-if="item.valueType === 'inputNumber'"
                :disabled="itemDisabled(formData, item.disabled)"
                v-model="formData[item.key]"
                controls-position="right"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                :min="item.min"
                :max="item.max"
                :step="1"
                step-strictly
              ></el-input-number>
              <!-- input 输入框-->
              <el-input
                :style="{ width: item.inputWidth }"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                @input="inputValidation(item.enableInput, item.key)"
                :maxlength="item.maxlength || 50"
                v-if="!item.valueType || item.valueType === 'input'"
                :type="item.inputType || 'text'"
                v-model="formData[item.key]"
                :disabled="itemDisabled(formData, item.disabled)"
                :placeholder="item.placeholder || '请输入' + item.label"
              ></el-input>
              <!-- textarea 多行输入框-->
              <el-input
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                :maxlength="item.maxlength || 200"
                :rows="item.rows || 1"
                :style="{ width: item.itemWidth ? item.itemWidth : '240px' }"
                v-if="item.valueType === 'textarea'"
                type="textarea"
                show-word-limit
                v-model="formData[item.key]"
                :disabled="itemDisabled(formData, item.disabled)"
                :placeholder="item.placeholder || '请输入' + item.label"
              ></el-input>

              <!-- select 下拉框 -->
              <el-select
                :multiple="item.multiple || false"
                filterable
                clearable
                :disabled="itemDisabled(formData, item.disabled)"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                v-if="item.valueType === 'select'"
                v-model="formData[item.key]"
                :placeholder="item.placeholder || '请选择' + item.label"
              >
                <el-option
                  v-for="(option, index) in item.data"
                  :key="index"
                  :disabled="
                    item.options
                      ? isDisabled(option, item.options['disabled'])
                      : false
                  "
                  :label="
                    item.options ? option[item.options['label']] : option.label
                  "
                  :value="
                    item.options ? option[item.options['value']] : option.value
                  "
                ></el-option>
              </el-select>
              <!-- 树形下拉选择 -->
              <span class="form-select-tree">
                <el-select
                  :disabled="itemDisabled(formData, item.disabled)"
                  clearable
                  class="form-select-drop"
                  v-if="item.valueType === 'tree-selected'"
                  v-model="formData[item.key]"
                  @clear="clearFn(item)"
                  placeholder="请选择"
                >
                  <el-option class="form-select-drop-options" value="">
                    <el-tree
                      :props="props"
                      @current-change="currentChange"
                      @node-click="nodeClick(item)"
                      :load="loadNode"
                      lazy
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </span>
              <!-- 联级下拉框 -->
              <CASCADER
                v-if="item.valueType === 'cascader'"
                :c="item"
                :formData="formData"
                :ref="item.ref"
                :placeholder="item.placeholder || '请选择' + item.label"
                :disabled="itemDisabled(formData, item.disabled)"
                @cascaderChange="
                  cascaderChange(item, formData[item.key], formData)
                "
                :showAllLevels="
                  item.config && item.config.showAllLevels
                    ? item.config.showAllLevels
                    : false
                "
              >
              </CASCADER>

              <!-- switch 选择器 -->
              <el-switch
                :disabled="itemDisabled(formData, item.disabled)"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                v-if="item.valueType === 'switch'"
                v-model="formData[item.key]"
              ></el-switch>

              <!--时间日期范围选择器-->
              <el-date-picker
                :disabled="itemDisabled(formData, item.disabled)"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                v-if="item.valueType === 'datetimerange'"
                v-model="formData[item.key]"
                type="datetimerange"
                value-format="timestamp"
                range-separator="至"
                :start-placeholder="
                  initPlaceholder(item.placeholder, 0) || '开始日期'
                "
                :end-placeholder="
                  initPlaceholder(item.placeholder, 1) || '结束'
                "
              >
              </el-date-picker>

              <!--日期选择器-->
              <el-date-picker
                :disabled="itemDisabled(formData, item.disabled)"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                v-if="item.valueType === 'date'"
                v-model="formData[item.key]"
                type="date"
                value-format="timestamp"
                :placeholder="item.placeholder || '请选择日期'"
              >
              </el-date-picker>

              <!--日期时间选择器-->
              <el-date-picker
                :disabled="itemDisabled(formData, item.disabled)"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                v-if="item.valueType === 'datetime'"
                v-model="formData[item.key]"
                :value-format="item.timeValueFormat || 'timestamp'"
                type="datetime"
                :placeholder="item.placeholder || '请选择时间'"
              >
              </el-date-picker>

              <!--日期范围选择器-->
              <el-date-picker
                :disabled="itemDisabled(formData, item.disabled)"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                class="date-range-box"
                v-if="item.valueType === 'daterange'"
                v-model="formData[item.key]"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                :start-placeholder="
                  initPlaceholder(i.placeholder, 0) || '开始日期'
                "
                :end-placeholder="initPlaceholder(i.placeholder, 1) || '结束'"
              >
              </el-date-picker>

              <!--时间范围选择器-->
              <el-time-picker
                v-if="item.valueType === 'timerange'"
                is-range
                v-model="formData[item.key]"
                range-separator="至"
                value-format="HH:mm:ss"
                :start-placeholder="
                  initPlaceholder(i.placeholder, 0) || '开始时间'
                "
                :end-placeholder="
                  initPlaceholder(i.placeholder, 1) || '结束时间'
                "
                placeholder="选择时间范围"
              >
              </el-time-picker>
              <!--月份选择器-->
              <el-date-picker
                v-if="item.valueType === 'month'"
                v-model="formData[item.key]"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月"
              >
              </el-date-picker>
              <!-- checkbox 多选框 -->
              <el-checkbox-group
                :disabled="itemDisabled(formData, item.disabled)"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                v-if="item.valueType === 'checkbox'"
                v-model="formData[item.key]"
              >
                <el-checkbox
                  v-for="(chenck, index) in item.data"
                  :key="index"
                  :label="chenck[item.options['value']] || chenck.value"
                >
                  {{ chenck[item.options["label"]] || chenck.label }}
                </el-checkbox>
              </el-checkbox-group>

              <!-- radio 单选框 -->
              <el-radio-group
                :disabled="itemDisabled(formData, item.disabled)"
                @change="item.fn ? item.fn(formData[item.key], formData) : ''"
                v-if="item.valueType === 'radio'"
                v-model="formData[item.key]"
              >
                <el-radio
                  v-for="(chenck, index) in item.data"
                  :key="index"
                  :label="chenck[item.options['value']] || chenck.value"
                  >{{ chenck[item.options["label"]] || chenck.label }}</el-radio
                >
              </el-radio-group>

              <!-- button -->
              <el-button
                :style="{ margin: item.marginLeft }"
                :type="item.type"
                v-if="item.valueType === 'button'"
                @click="item.fn"
              >
                {{ item.label }}
              </el-button>

              <!-- 固定标签 -->
              <div
                class="fixed-label-box"
                v-if="item.valueType === 'fixedLabel'"
              >
                <p
                  class="fixed-label"
                  v-for="(check, index) in item.data"
                  @click="fixedLabelClick(item, check)"
                  :class="labelClass(item, check)"
                  :key="index"
                >
                  {{ check[item.options["label"]] || check.label }}
                </p>
              </div>

              <!-- 自定义标签 -->
              <div
                class="custom-label-box"
                v-if="item.valueType === 'customLabel'"
              >
                <div
                  class="custom-label select"
                  v-for="(chenck, index) in formData[item.key]"
                  :key="index"
                >
                  <span>
                    {{
                      typeof chenck === "object"
                        ? chenck[item.options["label"]]
                        : chenck
                    }}
                    <i
                      v-if="
                        !formConfig.disabled &&
                          !itemDisabled(formData, item.disabled)
                      "
                      class="icon el-icon-close customLabelClose"
                      @click="deleteCustomLabel(item.key, chenck)"
                    ></i
                  ></span>
                  <!--                            <p @click="deleteCustomLabel(item.key, chenck)"><i class="icon el-icon-close"></i></p>-->
                </div>

                <p
                  v-if="
                    !formConfig.disabled &&
                      !itemDisabled(formData, item.disabled)
                  "
                  class="custom-label"
                  @click="item.fn ? item.fn(item) : showAddLabelDig(item)"
                >
                  <i class="icon el-icon-plus"></i>新增标签
                </p>
                <p class="custom-label" v-if="formConfig.disabled">新增标签</p>
              </div>

              <!-- 上传资源（图片, 视频等） -->
              <div class="upload-container" v-if="item.valueType === 'upload'">
                <div class="upload-box">
                  <!-- 图片回显 -->

                  <div
                    v-if="
                      $route.query.disabled && formData[item.key].length == 0
                    "
                    class="show-Img-box"
                    style="width: 140px;height:80px;border: 1px solid #f1f1f1;"
                  >
                    <div class="img-box" style="height: 100%">
                      <div class="button-box2" style="line-height: 60px">
                        <i class="icon el-icon-plus"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="show-Img-box"
                    v-for="(itemFile, index) in formData[item.key]"
                    :key="index"
                    :style="{
                      width:
                        item.otherConfig && item.otherConfig.imgWidth
                          ? item.otherConfig.imgWidth
                          : '190px',
                    }"
                  >
                    <div class="img-box bgBlack">
                      <div
                        v-if="
                          item.otherConfig &&
                          !formConfig.disabled &&
                          !itemDisabled(formData, item.disabled) &&
                          item.otherConfig.method &&
                          !item.otherConfig.method.includes('big')
                            ? true
                            : false
                        "
                        class="button-box"
                        :style="{
                          lineHeight:
                            item.otherConfig && item.otherConfig.imgHeight
                              ? item.otherConfig.imgHeight
                              : '130px',
                        }"
                      >
                        <input
                          style="display:none;"
                          class="formUPLoad"
                          type="file"
                          @change="
                            (uploadType = 'list'),
                              uploadVerification(
                                $event,
                                item.uploadConfig,
                                item.key
                              )
                          "
                          :accept="
                            item.uploadConfig ? item.uploadConfig.accept : ''
                          "
                        />
                        <i
                          v-if="
                            item.otherConfig &&
                            !formConfig.disabled &&
                            !itemDisabled(formData, item.disabled) &&
                            item.otherConfig.method
                              ? item.otherConfig.method.includes('edit')
                              : false
                          "
                          @click="editUpLoad(index, $event)"
                          class="icon el-icon-edit"
                        ></i>
                        <i
                          v-if="
                            item.otherConfig &&
                            !formConfig.disabled &&
                            !itemDisabled(formData, item.disabled) &&
                            item.otherConfig.method
                              ? item.otherConfig.method.includes('delete')
                              : false
                          "
                          @click="
                            (uploadType = 'list'), deleteFile(index, item.key)
                          "
                          class="icon el-icon-delete"
                        ></i>
                      </div>

                      <!--                                            <video v-if="showResources(item.uploadConfig)"-->
                      <!--                                                   :src="item.options ? itemFile[item.options.fileUrlKey] : itemFile.materialUrl"-->
                      <!--                                                   style="width: 100%;"-->
                      <!--                                                   :style="{height: item.otherConfig && item.otherConfig.imgHeight ? item.otherConfig.imgHeight : '130px'}"></video>-->

                      <div
                        v-if="
                          itemFile.suffixTypeValue == 'audio' ||
                            itemFile.suffixTypeValue == 'video'
                        "
                        class=""
                        style="overflow-wrap: break-word;word-break: normal;width: 100%; height: 110px;background: #ecf5ff;  border: 1px solid #0873ea4a; text-align: center;"
                      >
                        <img
                          style="height: 24px;width: 30px;padding-top: 40px"
                          src="../../assets/images/content/music.png"
                        />
                        <!-- <p>{{itemFile.name}}</p> -->
                        <!--                                                <p><i class="el-icon-service" style="font-weight: 900;font-size: 30px"></i></p>-->
                      </div>

                      <img
                        v-else
                        :src="
                          item.options && itemFile[item.options.fileUrlKey]
                            ? itemFile[item.options.fileUrlKey]
                            : itemFile.materialUrl
                        "
                        @mousemove="
                          showImgDig(
                            item.options
                              ? itemFile[item.options.fileUrlKey]
                              : itemFile.materialUrl,
                            item.otherConfig
                          )
                        "
                        alt=""
                        :style="{
                          height:
                            item.otherConfig && item.otherConfig.imgHeight
                              ? item.otherConfig.imgHeight
                              : '130px',
                        }"
                      />
                    </div>

                    <el-input
                      type="text"
                      v-if="
                        item.otherConfig
                          ? item.otherConfig.showInfoInput
                          : false
                      "
                      :maxLength="item.otherConfig.inputLength || 30"
                      :placeholder="
                        item.otherConfig
                          ? item.otherConfig.infoInputPlaceholder
                          : '请输入描述信息'
                      "
                      v-model="
                        itemFile[
                          item.options && item.options.fileInfoKey
                            ? item.options.fileInfoKey
                            : 'description'
                        ]
                      "
                    ></el-input>
                  </div>

                  <!-- 上传 -->
                  <div
                    class="item-upload-box"
                    v-if="
                      showUpload(
                        item.uploadConfig.count,
                        formData[item.key].length,
                        item.disabled
                      ) && !itemDisabled(formData, item.disabled)
                    "
                    :style="{
                      width:
                        item.otherConfig && item.otherConfig.imgWidth
                          ? item.otherConfig.imgWidth
                          : '190px',
                    }"
                  >
                    <div
                      :style="{
                        height:
                          item.otherConfig && item.otherConfig.imgHeight
                            ? item.otherConfig.imgHeight
                            : '130px',
                      }"
                    >
                      <i class="icon el-icon-plus"></i>
                      <input
                        type="file"
                        @change="
                          (uploadType = 'list'),
                            uploadVerification(
                              $event,
                              item.uploadConfig,
                              item.key
                            )
                        "
                        :accept="
                          item.uploadConfig ? item.uploadConfig.accept : ''
                        "
                      />
                    </div>
                    <!--                                                                        <span v-if="item.otherConfig.uploadHint">{{item.otherConfig.uploadHint}}</span>-->
                  </div>
                </div>
                <span
                  class="upload-hint"
                  v-if="
                    (item.otherConfig ? item.otherConfig.uploadHint : false) &&
                      !formConfig.disabled &&
                      !itemDisabled(formData, item.disabled)
                  "
                  >{{ item.otherConfig.uploadHint }}</span
                >
              </div>

              <!-- 单个资源上传 -->
              <div
                class="upload-container"
                v-if="item.valueType === 'singleUpload'"
              >
                <div class="upload-box">
                  <!-- 图片回显 -->
                  <div
                    v-if="
                      $route.query.disabled && formData[item.key].length == 0
                    "
                    class="show-Img-box;"
                    style=";width: 140px;height:80px;border: 1px solid #f1f1f1;"
                  >
                    <div class="img-box" style="height: 100%">
                      <div class="button-box2" style="line-height: 110px">
                        <i class="icon el-icon-plus"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="formData[item.key]"
                    class="show-Img-box"
                    :key="index"
                    :style="{
                      width:
                        item.otherConfig && item.otherConfig.imgWidth
                          ? item.otherConfig.imgWidth
                          : '190px',
                    }"
                  >
                    <div class="img-box bgBlack">
                      <div
                        v-if="
                          item.otherConfig &&
                          !formConfig.disabled &&
                          !itemDisabled(formData, item.disabled) &&
                          item.otherConfig.method &&
                          !item.otherConfig.method.includes('big')
                            ? true
                            : false
                        "
                        class="button-box"
                        :style="{
                          lineHeight:
                            item.otherConfig && item.otherConfig.imgHeight
                              ? item.otherConfig.imgHeight
                              : '130px',
                        }"
                      >
                        <input
                          style="display:none;"
                          class="formUPLoad"
                          type="file"
                          @change="
                            (uploadType = 'list'),
                              uploadVerification(
                                $event,
                                item.uploadConfig,
                                item.key
                              )
                          "
                          :accept="
                            item.uploadConfig ? item.uploadConfig.accept : ''
                          "
                        />
                        <i
                          v-if="
                            item.otherConfig &&
                            !formConfig.disabled &&
                            !itemDisabled(formData, item.disabled) &&
                            item.otherConfig.method
                              ? item.otherConfig.method.includes('edit')
                              : false
                          "
                          @click="editUpLoad(index, $event)"
                          class="icon el-icon-edit"
                        ></i>
                        <i
                          v-if="
                            item.otherConfig &&
                            !formConfig.disabled &&
                            !itemDisabled(formData, item.disabled) &&
                            item.otherConfig.method
                              ? item.otherConfig.method.includes('delete')
                              : false
                          "
                          @click="
                            (uploadType = 'list'), deleteFile(index, item.key)
                          "
                          class="icon el-icon-delete"
                        ></i>
                      </div>

                      <!--                                            <video v-if="showResources(item.uploadConfig)"-->
                      <!--                                                   :src="item.options ? itemFile[item.options.fileUrlKey] : itemFile.materialUrl"-->
                      <!--                                                   style="width: 100%;"-->
                      <!--                                                   :style="{height: item.otherConfig && item.otherConfig.imgHeight ? item.otherConfig.imgHeight : '130px'}"></video>-->

                      <div
                        v-if="itemFile.materialType == 'audio'"
                        class=""
                        style="overflow-wrap: break-word;word-break: normal;width: 100%; height: 110px;background: #ecf5ff;  border: 1px solid #0873ea4a; text-align: center;"
                      >
                        <img
                          style="height: 24px;width: 30px;padding-top: 40px"
                          src="../../assets/images/content/music.png"
                        />
                        <p>{{ itemFile.materialName + (index + 1) }}</p>
                        <!--                                                <p><i class="el-icon-service" style="font-weight: 900;font-size: 30px"></i></p>-->
                      </div>

                      <img
                        v-else
                        :src="
                          item.options && itemFile[item.options.fileUrlKey]
                            ? itemFile[item.options.fileUrlKey]
                            : itemFile.materialUrl
                        "
                        @mousemove="
                          showImgDig(
                            item.options
                              ? itemFile[item.options.fileUrlKey]
                              : itemFile.materialUrl,
                            item.otherConfig
                          )
                        "
                        alt=""
                        :style="{
                          height:
                            item.otherConfig && item.otherConfig.imgHeight
                              ? item.otherConfig.imgHeight
                              : '130px',
                        }"
                      />
                    </div>
                  </div>
                  <!-- 上传 -->
                  <div
                    class="item-upload-box"
                    v-if="!formData[item.key]"
                    :style="{
                      width:
                        item.otherConfig && item.otherConfig.imgWidth
                          ? item.otherConfig.imgWidth
                          : '190px',
                    }"
                  >
                    <div
                      :style="{
                        height:
                          item.otherConfig && item.otherConfig.imgHeight
                            ? item.otherConfig.imgHeight
                            : '150px',
                      }"
                    >
                      <i class="icon el-icon-plus"></i>
                      <input
                        type="file"
                        @change="
                          (uploadType = 'single'),
                            (uploadOption = item.options),
                            uploadVerification(
                              $event,
                              item.uploadConfig,
                              item.key
                            )
                        "
                        :accept="
                          item.uploadConfig ? item.uploadConfig.accept : ''
                        "
                      />
                    </div>
                    <!--                                                                        <span v-if="item.otherConfig.uploadHint">{{item.otherConfig.uploadHint}}</span>-->
                  </div>
                </div>
                <span
                  class="upload-hint"
                  v-if="
                    (item.otherConfig ? item.otherConfig.uploadHint : false) &&
                      !formConfig.disabled &&
                      !itemDisabled(formData, item.disabled)
                  "
                  >{{ item.otherConfig.uploadHint }}</span
                >
              </div>

              <!-- 文件上传-->
              <div class="upload-input" v-if="item.valueType === 'inputUpload'">
                <div v-if="formData[item.key].length > 0">
                  <div
                    class="file-box"
                    v-for="(itemFile, index) in formData[item.key]"
                    :key="index"
                  >
                    <input
                      type="text"
                      :value="
                        item.options
                          ? itemFile[item.options.fileUrlKey]
                          : itemFile.materialUrl
                      "
                    />
                    <button>上传</button>
                    <input
                      @change="
                        (uploadType = 'list'),
                          uploadVerification(
                            $event,
                            item.uploadConfig,
                            item.key,
                            index
                          )
                      "
                      type="file"
                      :accept="
                        item.uploadConfig ? item.uploadConfig.accept : ''
                      "
                    />
                  </div>
                </div>

                <div class="file-box" v-if="formData[item.key].length === 0">
                  <input type="text" />
                  <button>上传</button>
                  <input
                    @change="
                      (uploadType = 'list'),
                        uploadVerification(
                          $event,
                          item.uploadConfig,
                          item.key,
                          index
                        )
                    "
                    type="file"
                    :accept="item.uploadConfig ? item.uploadConfig.accept : ''"
                  />
                </div>
              </div>

              <!--富文本编辑器-->
              <UEDITOR
                v-if="item.valueType === 'ueditor' && item && formData"
                :disabled="formConfig.disabled"
                :dataConfig="item"
                :formData="formData"
              ></UEDITOR>

              <!-- 标点地图 -->
              <el-input
                class="input-location-box"
                v-if="item.valueType === 'inputMap'"
                :id="item.id"
                v-model="formData[item.key]"
                :placeholder="item.placeholder || '请输入' + item.label"
                type="text"
              >
                <el-button
                  slot="append"
                  icon="el-icon-location-outline"
                  @click="showMapFn(item)"
                ></el-button>
              </el-input>
              <!-- 经纬度绑定-->
              <div v-if="item.valueType === 'nautica'">
                <el-button size="mini" @click="showMapFn2(item)"
                  >绑定</el-button
                >
                <el-button
                  size="mini"
                  style="color: red"
                  @click="clearMapFn2(item, formData)"
                  >清除</el-button
                >
                <div
                  style="font-size: 10px;"
                  v-if="!!(formData.longitude && formData.latitude)"
                >
                  经度: {{ formData.longitude }} 纬度:{{ formData.latitude }}
                </div>
              </div>

              <div v-if="item.valueType === 'nautica2'" style="display: flex;">
                <el-input
                  v-model="formData[item.key]"
                  :disabled="itemDisabled(formData, item.disabled)"
                  :placeholder="item.placeholder || '请输入' + item.label"
                ></el-input>
                <el-button size="mini" @click="showMapFn2(item)"
                  >绑定</el-button
                >
                <!-- <el-button  size="mini" style="color: red" @click="clearMapFn2(item,formData)">清除</el-button> -->
                <!-- <div style="font-size: 10px;" v-if="!!(formData.longitude&&formData.latitude)">经度:{{formData.longitude}}  纬度:{{formData.latitude}}</div> -->
              </div>
              <!-- 评分 -->
              <el-rate
                :allow-half="item.allowHalf || false"
                v-if="item.valueType === 'rate'"
                show-text
                v-model="formData[item.key]"
                :colors="colors"
              ></el-rate>
            </el-form-item>
          </div>
        </div>
      </div>

      <!-- 表单按钮 -->
      <div
        class="edit-form-btn"
        :style="{
          marginLeft: buttonConfig.position || '100px',
          'justify-content': buttonConfig.position,
        }"
        v-if="showFormButton()"
      >
        <div
          style="display:inline-block;margin-right: 10px;"
          v-for="(i, index) in buttonConfig.buttons"
          :key="index"
        >
          <el-button
            v-if="i.type === 'save' && i.show !== false"
            :disabled="i.disabled || false"
            :loading="i.loading"
            :type="i.btnType ? i.btnType : 'primary'"
            @click="beforeSubmit('formData', i.fn, i)"
            >{{ i.title || "确定" }}</el-button
          >
          <el-button
            v-if="i.type === 'saveDrafts' && i.show !== false"
            :disabled="i.disabled || false"
            :loading="i.loading"
            type="primary"
            @click="i.fn ? i.fn(formData, i) : ''"
            >保存至草稿箱</el-button
          >
          <el-button
            v-if="i.type === 'reset' && i.show !== false"
            :disabled="i.disabled || false"
            :loading="i.loading"
            @click="formsForEach('formData', i.fn)"
            >重置</el-button
          >
          <el-button
            v-if="i.type === 'back' && i.show !== false"
            :disabled="i.disabled || false"
            :loading="i.loading"
            @click="goBack(i, 'formData')"
            >取消</el-button
          >
        </div>
      </div>
    </el-form>
    <div
      :style="{ justifyContent: 'center' }"
      v-if="$route.query.disabled == true"
    >
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
    <el-dialog
      title="图片"
      class="bigImgDialog"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div style="width: 100%; height: 250px;">
        <img :src="this.imgURL" style="width: 100%;height: 100%;" alt="" />
      </div>
    </el-dialog>
    <el-dialog
      title="位置"
      :visible.sync="mapConfig.mapDialogShow"
      :append-to-body="true"
      class="map-dialog"
      @close="mapConfig.mapInit = true"
      style="height: 800px;"
    >
      <div class="map-dialog-container">
        <div class="map-box">
          <el-input
            placeholder="请输入内容"
            v-model="mapConfig.siteName"
            @keyup.enter.native="searchSiteName()"
            style="position: absolute;top: 10px;left: 10px;z-index: 1"
          >
            <i
              slot="append"
              @click="searchSiteName()"
              class="el-icon-search"
            ></i>
          </el-input>
          <div :id="formConfig.ref" style="width: 100%;height: 400px"></div>
        </div>
        <div class="location-box">
          <span v-if="mapConfig.locBtn">位置坐标:</span>
          <p v-if="mapConfig.locBtn">
            <input v-model="mapConfig.position[0]" type="number" /> -
            <input type="number" v-model="mapConfig.position[1]" />
          </p>
          <el-button
            v-if="mapConfig.locBtn"
            type="primary"
            size="mini"
            style="margin-left: 20px;"
            @click="searchPosition(true)"
            >标注</el-button
          >
          <el-button
            v-if="mapConfig.locBtn"
            type="primary"
            size="mini"
            style="margin-left: 20px;"
            @click="saveSite()"
            >保存</el-button
          >
          <div class="" v-else style="text-align: center;width: 100%">
            <el-button
              type="primary"
              style="text-align: center"
              @click="saveSite()"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UEDITOR from "../ueditor-component/ueditor-component";
import CASCADER from "../cascader/cascader";
import publicVar from "../../assets/js/publicVar";
import publicAPI from "../../api-path/public-api";
// import {labelApi} from '../../api-path/public-api'
import AMap from "AMap";
// import TreeSelect from '@riophae/vue-treeselect'
export default {
  name: "edit-form",
  props: ["width", "rules", "ruleForm", "formConfig", "buttonConfig"],
  components: {
    UEDITOR,
    CASCADER,
    // TreeSelect
  },
  data() {
    return {
      //tree

      props: {
        label: "name",
        key: "id",
        children: "areaTreeListResList",
      },
      mapConfig: {
        saveCallBack: "",
        map: "", // 地图实例
        locBtn: true,
        mapDialogShow: false, // 地推显示
        mapInit: true, // 是否初始化map
        addressLocation: "", // 是否需要返回坐标
        siteName: "", // 地图查询名称
        position: [], // 当前坐标
        key: "", // 保存的值的key
      },

      // 自定义标签
      customLabelConfig: {
        addLabelDialogVisible: false, // 自定义标签弹窗
        resorceList: [], // 资源列表
        resorceType: "", // 资源类型
        selectedLabelValue: "",
        // path: labelApi.labelList, // 标签列表查询
        customLabelLsit: [], // 标签列表
        searchLabelLoading: true, // 自定义标签查询动画
      },

      dialogVisible: false, // 图片放大的弹框
      imgURL: "", // 放大的图片的路径
      upDataFileIndex: 999, // 上传图片 （999是新增 否则为编辑）

      uploadType: "list", // list: 上传列表  single: 单个
      uploadOption: {}, // 接收参数
      OYXInput: {}, // 记录验证通过的数据
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"], // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' },
    };
  },
  watch: {
    formData(newVal) {
      console.log(newVal);
    },
  },
  computed: {
    formData: {
      // 表单配置
      get: function() {
        if (this.$refs["formData"]) {
          this.$refs["formData"].clearValidate();
        }
        return this.ruleForm;
      },
      set: function(newValue) {
        return newValue;
      },
    },
  },
  created() {
    this.formConfig.disabled = this.$route.query.disabled ? true : false;
    this.initSelectData();
  },
  updated() {
    if (this.mapConfig.mapDialogShow && this.mapConfig.mapInit) {
      this.initMap();
      if (this.mapConfig.siteName) {
        this.searchSiteName();
      }
      this.mapConfig.mapInit = false;
      this.formConfig.disabled = this.$route.query.disabled ? true : false;
      this.initSelectData();
    }
  },
  methods: {
    loadNode(node, resolve) {
      const $this = this;
      if (node.level === 0) {
        let areaId = localStorage.getItem("centerId")
          ? localStorage.getItem("centerId")
          : "0";
        this.$http
          .get(publicAPI.subordinateList, {
            params: {
              id: areaId,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              $this.areaTreeList = res.result.areaTreeListResList;
              return resolve([res.result]);
            }
          });
      }
      if (node.level == 1) {
        return resolve(this.areaTreeList);
      }

      if (node.level > 1) {
        this.loadchildnode(node, resolve);
      }
    },
    loadchildnode(node, resolve) {
      this.$http
        .get(publicAPI.subordinateList, {
          params: {
            id: node.data.id,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            return resolve(res.result.areaTreeListResList);
          }
        });
    },
    currentChange(node) {
      this.currentNode = node;
    },
    nodeClick(item) {
      if (this.currentNode.id) {
        //根节点不可点
        item.fn(this.currentNode);
      }
      // this.formData['parentId']=this.currentNode.areaId;
    },
    /*------------渲染规则验证--------------*/
    // 初始化的数据
    initSelectData() {
      for (let i of this.formConfig.items) {
        i.forEach((k) => {
          const valueTypes = ["select", "checkbox", "radio", "fixedLabel"];
          if (valueTypes.includes[k.valueType] !== -1 && k.path && !k.data) {
            let qs = require("qs");
            let search = qs.parse(k.path.split("?")[1]);
            // 匹配字典表
            if (k.path.indexOf("codeValue") !== -1) {
              const code = this.matchFn.matchCode(search.codeValue);
              if (code) {
                this.$set(k, "data", code);
                return;
              }
            }
            this.searchCode(k, search);
          }

          if (k.valueType === "input") {
            this.OYXInput[k.key] = this.formData[k.key]
              ? String(this.formData[k.key]).length
              : 0;
          }
        });
      }
    },

    // 匹配xuan'z
    matchSelectType() {},

    // 查询字典表
    searchCode(k, search) {
      this.$http.get(k.path).then((res) => {
        if (res.result && res.status === 200) {
          if (k.valueType === "select" && k.path.indexOf("codeValue") !== -1) {
            this.$set(k, "data", res.result[search.codeValue]);
          } else {
            if (res.result.__proto__ === Array.prototype) {
              this.$set(k, "data", res.result);
            } else {
              this.$set(k, "data", res.result.pageList);
            }
          }
        }
      });
    },

    //返回
    goBack(i, formName) {
      if (i.fn) {
        i.fn();
      } else {
        this.resetForm(formName);
        this.$router.back(-1);
      }
    },

    //清除下拉列表输入框数据
    clearFn(item) {
      if (item.clearFn) {
        item.clearFn();
      }
      this.ruleForm[item.key] = "";
      this.ruleForm[item.id] = "";
    },

    // 初始化输入框提示信息
    initPlaceholder(placeholder, index) {
      if (!placeholder || placeholder.indexOf(":") === -1) {
        return false;
      }
      let keyValue = placeholder.split(":");
      return keyValue[index];
    },

    // 输入信息验证
    inputValidation(enableInput, key) {
      const verificationResult = [];
      if (enableInput) {
        enableInput.forEach((item) => {
          verificationResult.push(publicVar[item].test(this.formData[key]));
        });
        const OXY = verificationResult.some((item) => item === true);
        if (!OXY) {
          if (this.formData[key].length == 1) {
            this.formData[key] = "";
          } else {
            this.formData[key] = this.formData[key].slice(
              0,
              this.OYXInput[key]
            );
          }
        } else {
          this.OYXInput[key] = this.formData[key].length;
        }
      }
    },
    isTrue(arr) {
      console.log(arr);
    },

    // 是否显示表单按钮
    showFormButton() {
      if (this.formConfig.disabled) {
        return false;
      }
      if (
        !this.buttonConfig ||
        !this.buttonConfig.buttons ||
        this.buttonConfig.buttons.length <= 0
      ) {
        return false;
      }
      return true;
    },
    // 是否显示上传
    showUpload(maxCount, fileCount, disabled) {
      if (this.formConfig.disabled) {
        return false;
      }
      if (disabled) {
        return false;
      }
      if (!maxCount && fileCount < 1) {
        return true;
      }
      if (fileCount < maxCount) {
        return true;
      }
      if (fileCount >= maxCount) {
        return false;
      }
    },

    // 禁用
    itemDisabled(data, show) {
      if (typeof show === "string") {
        if (show === "disabled") {
          return true;
        }
        show = show.replace(/\s+/g, "");
        let params = show.slice(0, show.indexOf("="));
        let params1 = show.slice(show.indexOf("="), show.length);
        return eval(`data.${params}${params1}`);
      }
      if (typeof show === "boolean") {
        return show;
      }
      return false;
    },

    // 下拉框禁用
    isDisabled(data, show) {
      if (typeof show === "boolean") {
        return show;
      }
      if (show) {
        show = show.replace(/\s+/g, "");
        let params = show.slice(0, show.indexOf("="));
        let params1 = show.slice(show.indexOf("="), show.length);
        return eval(`data.${params}${params1}`);
      } else {
        return false;
      }
    },

    // 是否显示每一项
    showItem(data, show) {
      if (typeof show === "boolean") {
        return show;
      }
      if (show) {
        show = show.replace(/\s+/g, "");
        let params = show.slice(0, show.indexOf("="));
        let params1 = show.slice(show.indexOf("="), show.length);
        return eval(`data.${params}${params1}`);
      } else {
        return true;
      }
    },

    /*--------------地图----------------*/
    showMapFn(data) {
      this.mapConfig.locBtn = true;
      this.mapConfig.mapDialogShow = true;
      this.mapConfig.saveCallBack = data.fn;
      this.mapConfig.key = data.key;
      this.mapConfig.siteName = this.formData[data.key];
      this.mapConfig.addressLocation = data.addressLocation;
    },
    showMapFn2(data) {
      this.mapConfig.locBtn = false;
      this.mapConfig.mapDialogShow = true;
      this.mapConfig.saveCallBack = data.fn;
      this.mapConfig.key = data.key;
      this.mapConfig.siteName = this.formData[data.key];
      this.mapConfig.addressLocation = data.addressLocation;
    },
    clearMapFn2(data, dd) {
      console.log(data, dd);
      this.formData.longitude = "";
      this.formData.latitude = "";
    },

    // 初始化地图
    initMap() {
      this.mapConfig.map = new AMap.Map(this.formConfig.ref, {
        resizeEnable: true,
        zoom: 8,
        viewMode: "2D",
        zooms: [7, 18],
      });
      if (this.formData.longitude != "" && this.formData.latitude != "") {
        const _this = this;
        AMap.plugin("AMap.Geocoder", function() {
          const geocoder = new AMap.Geocoder({
            city: "0",
          });
          const lnglat = [_this.formData.longitude, _this.formData.latitude];
          _this.mapConfig.position = lnglat;
          geocoder.getAddress(lnglat, function(status, result) {
            if (status === "complete" && result.info === "OK") {
              _this.mapConfig.siteName = result.regeocode.formattedAddress;
              _this.mapConfig.map.setCenter(lnglat);
              _this.mapConfig.map.setZoom(13);
              _this.addMarker(lnglat);
            }
          });
        });
      }
      this.clickOn();
    },

    // map事件绑定
    clickOn() {
      this.mapConfig.map.on("click", this.showInfoClick);
    },

    //  map解绑事件
    clickOff() {
      this.mapConfig.map.off("click", this.showInfoClick);
    },

    // 地址逆查询
    searchSiteName() {
      const _this = this;
      AMap.plugin("AMap.Geocoder", function() {
        const geocoder = new AMap.Geocoder({
          city: "0",
        });
        geocoder.getLocation(_this.mapConfig.siteName, function(
          status,
          result
        ) {
          if (status === "complete" && result.info === "OK") {
            const position = [
              result.geocodes[0].location.lng,
              result.geocodes[0].location.lat,
            ];
            _this.mapConfig.map.setZoom(13);
            _this.mapConfig.position = position;
            _this.mapConfig.map.setCenter(position);
            _this.addMarker(position);
          }
        });
      });
    },

    // 坐标查询
    searchPosition() {
      if (this.mapConfig.position.length !== 2) {
        return false;
      }
      const _this = this;
      AMap.plugin("AMap.Geocoder", function() {
        const geocoder = new AMap.Geocoder({
          city: "0",
        });
        const lnglat = _this.mapConfig.position;
        geocoder.getAddress(lnglat, function(status, result) {
          if (status === "complete" && result.info === "OK") {
            _this.mapConfig.siteName = result.regeocode.formattedAddress;
            _this.mapConfig.map.setCenter(lnglat);
            _this.mapConfig.map.setZoom(13);
            _this.addMarker(lnglat);
          }
        });
      });
    },

    // 点击事件
    showInfoClick(e) {
      this.mapConfig.position = [e.lnglat.lng, e.lnglat.lat];
      this.searchPosition();
    },

    // 添加标记
    addMarker(lnglat) {
      this.mapConfig.map.clearMap();
      const marker = new AMap.Marker({
        position: lnglat,
        offset: new AMap.Pixel(-15, -35),
        icon: require("../../assets/images/map/position.png"),
      });
      this.mapConfig.map.add(marker);
    },

    // 保存地址
    saveSite() {
      this.formData[this.mapConfig.key] = this.mapConfig.siteName;
      if (this.mapConfig.addressLocation) {
        this.formData[this.mapConfig.addressLocation] = this.mapConfig.position;
      }
      this.formData["longitude"] = this.mapConfig.position[0];
      this.formData["latitude"] = this.mapConfig.position[1];
      if (this.mapConfig.saveCallBack) {
        // 回调
        this.mapConfig.saveCallBack({
          siteName: this.mapConfig.siteName,
          location: {
            longitude: this.mapConfig.position[0],
            latitude: this.mapConfig.position[1],
          },
        });
      }
      this.mapConfig = Object.assign(
        this.mapConfig,
        this.$options.data().mapConfig
      );
    },

    /*--------------区域联级下拉----------------*/
    // 初始化联级下拉的配置
    initCascaderProp(c) {
      let props = {
        multiple: false,
        value: "id",
        label: "areaName",
        lazy: true,
        lazyLoad: this.lazyLoad,
        checkStrictly:
          c.config && c.config.checkStrictly ? c.config.checkStrictly : false,
      };
      this.leaf = c.config && c.config.level ? c.config.level : false;
      props = { ...props, ...c.option };
      return props;
    },

    // 连级查询
    lazyLoad(node, resolve) {
      const { level } = node;
      this.$http
        .get(
          `${publicAPI.areaListTreeNode}?parentId=${
            node.data ? node.data.id : 0
          }`
        )
        .then((res) => {
          if (res.status === 200) {
            if (res.result) {
              res.result.map((item) => {
                if (this.leaf) {
                  item.leaf = level >= this.leaf ? true : false;
                }
              });
              resolve(res.result);
            } else {
              resolve();
            }
          }
        });
    },

    // 值改变时
    cascaderChange(c, value, formData) {
      const obj = {
        value: value,
      };
      if (c.ref) {
        const pathLabels = this.$refs[
          c.ref
        ][0].$refs.cascader.getCheckedNodes()[0].pathLabels;
        obj.label = pathLabels.join("");
      }

      if (c.fn) {
        c.fn(obj, formData);
      }
    },

    /*----------------------标签------------------------*/
    // 删除自定义标签
    deleteCustomLabel(key, data) {
      if (this.formConfig.disabled) {
        return false;
      }
      this.formData[key] = this.formData[key].filter((item) => item !== data);
    },

    // 显示自定义标签弹窗
    showAddLabelDig(data) {
      console.log(data);
      // this.customLabelConfig.addLabelDialogVisible = true
      // this.getResorceList()
      // this.customLabelConfig = {...this.customLabelConfig, ...data}
    },

    // 获取资源类型
    // getResorceList() {
    //     this.$http.get(labelApi.typeList).then(res => {
    //         if(res.status === 200) {
    //             this.customLabelConfig.resorceList = res.result
    //         }
    //     })
    // },
    // 查询自定义标签
    remoteMethod(query, inx) {
      let resourceType = "";
      if (inx) {
        this.customLabelConfig.selectedLabelValue = "";
        this.customLabelConfig.resorceList.forEach((it) => {
          if (this.customLabelConfig.resorceType == it.itemValue) {
            resourceType = it.itemName;
          }
        });
      } else {
        query = query.slice(0, 30);
      }

      this.customLabelConfig.searchLabelLoading = true;
      const params = {
        name: query,
        resourceType: resourceType,
        page: 1,
        size: 20,
      };
      this.$http
        .get(this.customLabelConfig.path, {
          params,
        })
        .then((res) => {
          this.customLabelConfig.customLabelLsit = [];
          if (res.status === 200) {
            this.customLabelConfig.customLabelLsit = res.result.pageList;
            this.initCustomData(query);
          }
          this.customLabelConfig.searchLabelLoading = false;
        });
    },

    // 自定义标签数据初始化
    initCustomData(query) {
      const label = this.customLabelConfig.options.label;
      const value = this.customLabelConfig.options.value;
      for (let i in this.customLabelConfig.customLabelLsit) {
        if (this.customLabelConfig.customLabelLsit[i][label] === query) {
          return false;
        }
      }

      if (!query) {
        return false;
      }

      this.customLabelConfig.customLabelLsit.push({
        [label]: query,
        [value]: query,
      });
    },

    // 固定标签class
    labelClass(config, chenck) {
      if (this.formData[config.key].__proto__.__proto__ !== Array.prototype) {
        throw new Error(
          `The type of ${config.key} should be Array, not ${typeof this
            .formData[config.key]}`
        );
      }

      if (config.options && config.options.value) {
        if (this.formData[config.key].includes(chenck[config.options.value])) {
          return "selected";
        }
      }
    },
    // 固定标签点击事件
    fixedLabelClick(config, chenck) {
      /*
       * 1. 是否disabled
       * 2. 有count 且count > 1则为多选
       * 3. 有count 那么值为数组
       * 4. 值的length >= count则取消选中 否则判断是否已为选中状态，选中则取消，未选中则选中
       * */
      if (this.formConfig.disabled) {
        return false;
      }
      if (config.count && config.count > 1) {
        if (this.formData[config.key].__proto__.__proto__ !== Array.prototype) {
          throw new Error(
            `The type of ${config.key} should be Array, not ${typeof this
              .formData[config.key]}`
          );
        }

        if (config.count > this.formData[config.key].length) {
          if (config.options && config.options.value) {
            const exist = this.formData[config.key].some(
              (item) => item === chenck[config.options.value]
            );
            if (!exist) {
              this.formData[config.key].push(chenck[config.options.value]);
            } else {
              this.formData[config.key] = this.formData[config.key].filter(
                (item) => item !== chenck[config.options.value]
              );
            }
          }
        } else {
          if (config.options && config.options.value) {
            this.formData[config.key] = this.formData[config.key].filter(
              (item) => item !== chenck[config.options.value]
            );
          }
        }
      } else {
        this.formData[config.key] = [];
        this.formData[config.key].push(chenck[config.options.value]);
      }

      if (config.fn) {
        config.fn(this.formData[config.key], this.formData);
      }
    },

    /*-------------------文件上传-----------------------*/
    // 上传验证
    uploadVerification(e, uploadConfig, key, index) {
      const file = e.target.files[0];
      let size = 0;
      let fileType = file.name.slice(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );

      if (uploadConfig) {
        const accept = uploadConfig ? uploadConfig.accept : "";
        // 格式验证
        if (uploadConfig.accept && accept.indexOf(fileType) === -1) {
          this.$message.error("文件类型错误");
          return false;
        }

        // 大小验证
        if (uploadConfig.size) {
          if (
            uploadConfig.size.indexOf("m") ||
            uploadConfig.size.indexOf("M")
          ) {
            size = parseInt(uploadConfig.size) * 1024;
          }

          if (uploadConfig.size.indexOf("kb") !== -1) {
            size = parseInt(uploadConfig.size);
          }
          if (file.size / 1024 > size) {
            this.$message.error(`文件大小不能超过${uploadConfig.size}`);
            return false;
          }
        }
      }

      if (index) {
        this.upDataFileIndex = index;
      }

      this.initiateUploadRequest(uploadConfig, file, key);
      e.target.value = "";
    },

    // 显示图片
    showResources(c) {
      if (c && c.accept) {
        if (
          c.accept.indexOf("video") !== -1 ||
          c.accept.indexOf("audio") !== -1
        ) {
          return true;
        } else return false;
      }
      return false;
    },

    // 触发上传
    editUpLoad(index, e) {
      let input = e.currentTarget.previousElementSibling;
      input.click();
      this.upDataFileIndex = index;
    },

    // 上传(用于列表)
    initiateUploadRequest(uploadConfig, file, key) {
      const requestPath =
        uploadConfig && uploadConfig.uploadPath
          ? uploadConfig.uploadPath
          : publicAPI.uploadFile;
      const formData = new FormData();
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      formData.append("file", file);
      if (uploadConfig && uploadConfig.params) {
        let params = uploadConfig.params.replace(/\s+/g, "");
        params = params.split(":");
        formData.append(params[0], params[1]);
      } else {
        formData.append("materType", "");
      }
      this.$http
        .post(requestPath, formData, {
          headers,
        })
        .then((res) => {
          if (res.status !== 200) {
            return false;
          }
          // 列表上传数据处理
          if (this.uploadType === "list") {
            if (this.upDataFileIndex !== 999) {
              console.log(1111111111111);
              this.ruleForm[key].splice(this.upDataFileIndex, 1, res.result);
              this.upDataFileIndex = 999;
              return false;
            }
            this.ruleForm[key].push(res.result);
          } else {
            // 单张上传数据处理
            this.ruleForm[key] = res.result.url;

            // this.ruleForm[key] = this.uploadOption && this.uploadOption.fileUrlKey ? res.result['url'] : res.result.url
          }
        });
    },

    // 显示图片
    showImgDig(imgURL, config) {
      if (this.formConfig.disabled) {
        return false;
      }

      if (config && config.method && !config.method.includes("big")) {
        return false;
      }
      this.dialogVisible = true;
      this.imgURL = imgURL;
    },

    // 删除文件
    deleteFile(index, key) {
      if (this.formConfig.disabled) {
        return false;
      }

      if (this.uploadType === "list") {
        this.ruleForm[key].splice(index, 1);
      } else {
        this.ruleForm[key] = "";
      }
    },

    /*-----------------------表单验证-------------------*/
    //  提交前
    beforeSubmit(formName, fn, i) {
      i.loading = true;
      const validateAll = this.buttonConfig.validateAll;
      if (validateAll && validateAll.length > 0) {
        // 需要验证多张表单
        this.formsValidate(validateAll, fn, i);
      } else {
        this.submitForm(formName, fn, false, i);
      }
      i.loading = false;
    },

    // 多张表单验证
    formsValidate(validateAll, fn, i) {
      console.log("11111");
      let validateState = [];
      validateAll.forEach((item) => {
        if (this.$parent.$refs[item]) {
          this.$parent.$refs[item].submitForm("formData", fn, validateState);
        } else {
          this.$parent.$parent.$refs[item].submitForm(
            "formData",
            fn,
            validateState
          );
        }

        if (validateState.length === validateAll.length) {
          if (validateState.includes(false)) {
            this.$message.error("请填写完所有必填项");
          } else {
            i.loading = true;
            fn(this.ruleForm);
          }
        }
      });
    },

    // 表单验证
    submitForm(formName, fn, state, i) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (state) {
            state.push(valid);
            return false;
          }

          if (fn) {
            i.loading = true;
            fn(this.formData);
          }
        } else {
          if (state) {
            state.push(false);
            return false;
          }
          this.$message.error("请填写完所有必填项");
          return false;
        }
      });
    },
    /*----------------------表单重置---------------------*/
    formsForEach(formName, fn) {
      const validateAll = this.buttonConfig.validateAll;
      if (validateAll && validateAll.length > 0) {
        validateAll.forEach((item) => {
          if (this.$store.state.setThis.$refs[item]) {
            this.$store.state.setThis.$refs[item].resetForm(formName, fn);
          } else {
            this.$parent.$refs[item].resetForm(formName, fn);
          }
        });
        if (fn) {
          fn(this.formData);
        }
      } else {
        this.resetForm(formName, fn);
        if (fn) {
          fn(this.formData);
        }
      }
    },

    // 重置
    resetForm(formName, fn) {
      const data = this.$parent.$options.data
        ? this.$parent.$options.data().ruleForm
        : this.$store.state.setThis.$options.data().ruleForm;
      this.formData = Object.assign(this.formData, data);
      this.$refs[formName].resetFields();
      if (fn) {
        fn();
      }
    },
  },
};
</script>

<style lang="less">
.edit-form {
  .bigImgDialog .el-dialog {
    min-height: 350px;
    height: 350px;
  }

  textarea.el-textarea__inner {
    padding: 10px;
  }

  .addLabelDialog .el-dialog {
    min-height: 200px;
    height: 300px;
  }

  .upload-box {
    .el-input__inner,
    .el-input {
      height: 24px;
      line-height: 24px;
    }

    .el-input {
      width: 100%;
      margin-top: 5px;
    }
  }
}

.form-select-drop-options {
  height: auto !important;
  line-height: normal !important;
  padding: 0 !important;
}
</style>
<style scoped lang="less">
@import "edit-form";
</style>
